module.exports = __webpack_public_path__ + "img/trial4-1.e48c9b96.png";